//librerias
import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-modal-check",
  templateUrl: "./modal-check.component.html",
})
export class ModalCheckComponent {
  @Input() datos = [];
  @Output() Confirm = new EventEmitter();
  @Output() Close = new EventEmitter();

  confirm() {
    this.Confirm.emit();
  }

  close() {
    this.Close.emit();
  }
}
